module.exports = __webpack_public_path__ + "img/Check.8c87cbb2.svg";